<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { config } from '@/config'

const idpUrl = config.idpUrl
const currentUrl = `${window.location.host}/${window.location.pathname}`
const { t } = useI18n({ useScope: 'global' })

function retry() {
  window.location.href = `${idpUrl}?url=${encodeURIComponent(currentUrl)}&scope=virtual-agent`
}
</script>

<template>
  <div class="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-6 py-12">
    <OCardAdvanced>
      <div class="col-span-2">
        <h1 class="text-2xl font-semibold text-gray-900 text-center">{{ t('error.title') }}</h1>

        <p class="mt-4 text-center text-sm text-gray-600">
          {{ t('error.subtitle') }}
        </p>

        <div class="mt-8 flex flex-col space-y-3">
          <OButton type="button" :label="t('retry')" @click="retry" />
        </div>
      </div>
    </OCardAdvanced>

    <p class="mt-8 text-xs text-gray-500 text-center">{{ t('error.persist') }}</p>
  </div>
</template>
